import { useState, useEffect, useMemo } from "react";
import _ from "lodash";

import TimesheetViewMode from "./TimesheetViewMode";
import DayIndicator from "./DayIndicator";
import TotalTimesheet from "./TotalTimesheet";
import DayTimesheet from "./DayTimesheet";
import TechnicianService from "src/Services/API/technician.service";
import { getMinutesFromFormattedHours, handleError } from "src/Common/function";

const Timesheet = ({ order, onTotalMinutes }) => {
  const [viewMode, setViewMode] = useState("total");
  const [currentDate, setCurrentDate] = useState(new Date());
  const [timesheetData, setTimesheetData] = useState([]);

  const getTimesheetData = () => {
    TechnicianService.getTimesheetByWoId(order.id)
      .then((response) => {
        if (response.status == 200) {
          let assignedTechs = _.cloneDeep(response.data);
          for (let i = 0; i < assignedTechs.length; i++) {
            if (assignedTechs[i].timesheet) {
              assignedTechs[i].timesheet = JSON.parse(assignedTechs[i].timesheet);
              assignedTechs[i].totalTimesheet = JSON.parse(
                assignedTechs[i].totalTimesheet
              );
            }
          }
          setTimesheetData(assignedTechs);
        }
      })
      .catch((error) => handleError(error));
  };

  useEffect(() => {
    getTimesheetData();
  }, [order]);

  // WO-wide labor total (regular + travel + overtime across all techs and
  // days), surfaced in the section card header as "Total Labor Hours".
  const totalLaborMinutes = useMemo(() => {
    let total = 0;
    for (const tech of timesheetData) {
      if (!tech?.timesheet) continue;
      for (const entry of tech.timesheet) {
        total +=
          getMinutesFromFormattedHours(entry.regularTime) +
          getMinutesFromFormattedHours(entry.travelTime) +
          getMinutesFromFormattedHours(entry.overTime);
      }
    }
    return total;
  }, [timesheetData]);

  useEffect(() => {
    if (onTotalMinutes) {
      onTotalMinutes(totalLaborMinutes);
    }
  }, [totalLaborMinutes, onTotalMinutes]);

  return (
    <div>
      <div className="flex items-center justify-between px-5 py-3 bg-white border-b border-[#E5E8F3]">
        <TimesheetViewMode value={viewMode} onChange={setViewMode} />
        <DayIndicator
          startDateString={order.startDateString}
          viewMode={viewMode}
          currentDateChanged={setCurrentDate}
          timesheetData={timesheetData}
        />
      </div>
      {viewMode === "total" ? (
        <TotalTimesheet
          timesheetData={timesheetData}
          currentDate={currentDate}
          startDateString={order.startDateString}
        />
      ) : (
        <DayTimesheet
          timesheetData={timesheetData}
          currentDate={currentDate}
          startDateString={order.startDateString}
          timesheetUpdated={getTimesheetData}
          woStatus={order.status}
        />
      )}
    </div>
  );
};

export default Timesheet;
